import { styled } from '@linaria/react';
import { bodyFont, colors, fonts, headingFont, space } from '../../theme/tokens';

export const FooterBar = styled.footer<{ $align?: 'left' | 'right' }>`
  position: sticky;
  bottom: 0;
  background: ${colors.white};
  border-top: 1px solid ${colors.lighterGrey};
  padding: ${space[4]} ${space[5]};
  display: flex;
  align-items: center;
  justify-content: ${({ $align }) => ($align === 'right' ? 'flex-end' : 'space-between')};
  gap: ${space[5]};
  z-index: 10;
  width: 100%;
  box-sizing: border-box;
`;

export const FooterLeft = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${space[1]};
`;

export const FooterTitle = styled.span`
  font-family: ${headingFont};
  font-size: ${fonts.size.base};
  font-weight: ${fonts.weight.semiBold};
  color: ${colors.fontPrimary};
`;

export const FooterTotal = styled.span`
  font-family: ${bodyFont};
  font-size: ${fonts.size.md};
  font-weight: ${fonts.weight.bold};
  color: ${colors.fontPrimary};
`;

export const FooterOriginalPrice = styled.span`
  font-family: ${bodyFont};
  font-size: ${fonts.size.md};
  font-weight: ${fonts.weight.normal};
  color: ${colors.grey};
  text-decoration: line-through;
`;

export const FooterDiscountedPrice = styled.span`
  font-family: ${bodyFont};
  font-size: ${fonts.size.md};
  font-weight: ${fonts.weight.bold};
  color: ${colors.fontPrimary};
`;

export const FooterPriceRow = styled.span`
  display: inline-flex;
  align-items: baseline;
  gap: 0.4rem;
`;
